var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{staticStyle:{"position":"absolute","left":"50%","top":"50%","transform":"translate(-50%, -50%)"},attrs:{"indeterminate":"","size":90,"color":"grey","rounded":""},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('span',{staticClass:"text-overline"},[_vm._v("Loading")])])
}
var staticRenderFns = []

export { render, staticRenderFns }